import React, {RefObject} from 'react';
import {SCREEN_WIDTH} from 'constants/config';

interface IEditTimeline {
  totalDuration: number;
  rightEndTime: number;
  timelineRef: RefObject<HTMLCanvasElement>;
  lastLineRef: RefObject<HTMLDivElement>;
  prevSectionBtn: boolean;
  NextSectionBtn: boolean;
  onClickPrevSection: () => void;
  onClickNextSection: () => void;
}

/**
 * 편집 영역 타임라인 컴포넌트
 */

const EditTimeline = ({
  timelineRef,
  prevSectionBtn,
  NextSectionBtn,
  onClickPrevSection,
  onClickNextSection,
}: IEditTimeline) => {
  return (
    <div className='timeline_wrap'>
      {prevSectionBtn && (
        <button
          className='headline_move left'
          onClick={onClickPrevSection}></button>
      )}
      <canvas
        id='timeline'
        className='timeline'
        width={`${SCREEN_WIDTH - 170}px`}
        height='50px'
        ref={timelineRef}></canvas>
      {NextSectionBtn && (
        <button
          className='headline_move right'
          onClick={onClickNextSection}></button>
      )}
    </div>
  );
};

export default EditTimeline;
